import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, ButtonGroup, Col, Label, Row } from 'reactstrap';
import { AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';
import { createEntity, getEntity, getMasterEntities, reset, updateEntity } from './mmama-entity.reducer';
import { hasAnyPermission } from 'app/shared/auth/permissions';
import { getAllByType as getCountries } from 'app/entities/region/region.reducer';
import { IRegion } from 'app/shared/model/region.model';
import { IMmamaEntityMaster } from 'app/shared/model/mmama-entity-master.model';

export interface IMmamaEntityUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{
  id: string
}> {
}

export const MmamaEntityUpdate = (props: IMmamaEntityUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);
  const {
    mmamaEntityEntity,
    masterEntities,
    countries,
    userCountryId,
    loading,
    updating,
    hasUpdateAccess,
  } = props;
  const [activeStatus, setActiveStatus] = useState(true);
  const [mandatoryStatus, setMandatoryStatus] = useState(false);
  const [activeCountry, setActiveCountry] = useState<IRegion>({});
  const [activeMasterEntity, setActiveMasterEntity] = useState<IMmamaEntityMaster>({});
  const [regCountriesList, setRegCountriesList] = useState<IRegion[]>([]);
  const masterEntityId = new URLSearchParams(props.location.search).get('masterEntityId') ?? null;
  const countryIdParam = new URLSearchParams(props.location.search).get('countryId') ?? null;

  const handleClose = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    props.getCountries();
    props.getMasterEntities();
  }, []);

  useEffect(() => {
    if ((isNew || mmamaEntityEntity.id) && userCountryId && countries.length > 0 && masterEntities.length > 0) {
      let ac: IRegion;
      if (isNew) {
        if (countryIdParam) {
          ac = countries.find(country => country.id === countryIdParam);
        } else {
          ac = countries.find(country => country.id === (props.isAdmin ? countries[0].id : props.userCountryId));
        }
      } else {
        ac = countries.find(country => country.id === mmamaEntityEntity?.countryId);
      }
      if (ac) {
        setActiveCountry(ac);
      }

      const allowedCountries = countries.filter((ele) => {
        return props.isAdmin ? 1 : ele.id === userCountryId;
      });
      setRegCountriesList(allowedCountries);

      if (masterEntityId) {
        const ame = masterEntities.find(masterEntity => masterEntity.id === masterEntityId);
        if (ame) {
          setActiveMasterEntity(ame);
        }
      } else {
        setActiveMasterEntity(masterEntities[0]);
      }
    }
  }, [countries, userCountryId, mmamaEntityEntity, masterEntities]);

  const onCountryChange = (event) => {
    const countryId = event.target.value;
    const newActiveCountry = countries.find(country => country.id === countryId);
    setActiveCountry(newActiveCountry);
  };

  const onMasterEntityChange = (event) => {
    const newMasterEntityId = event.target.value;
    const newMasterEntity = masterEntities.find(masterEntity => masterEntity.id === newMasterEntityId);
    setActiveMasterEntity(newMasterEntity);
  };

  useEffect(() => {
    if (!isNew) {
      setActiveStatus(mmamaEntityEntity.isActive);
      setMandatoryStatus(!!mmamaEntityEntity.required);
    }
  }, [mmamaEntityEntity]);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...mmamaEntityEntity,
        ...values,
        countryId: activeCountry.id,
        isActive: activeStatus,
        required: mandatoryStatus
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };


  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="mmamaApp.mmama.entity.home.createOrEditLabel">
            {isNew ? 'Add Feedback Entry' : 'Edit Feedback Entry'}
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>loading...</p>
          ) : (
            <AvForm model={isNew ? {} : mmamaEntityEntity} onSubmit={saveEntity}>
              <br />
              {!isNew ? (
                <AvGroup>
                  <Label for="mmama-entity-id">ID</Label>
                  <AvInput id="mmama-entity-id" type="text" className="form-control" name="id" required
                           readOnly />
                </AvGroup>
              ) : null}

              <br />
              <div className="mt-3">
                <Row className="justify-content-left">
                  <Col md="6">
                    <AvGroup>
                      <Label id="isActive" for="mmama-entity-isActive">
                        Is Active
                      </Label>
                      <ButtonGroup style={{ marginLeft: '30px' }}>
                        <Button
                          color={activeStatus ? 'primary' : 'secondary'}
                          onClick={(e) => {
                            setActiveStatus(true);
                          }}
                        >
                          Yes
                        </Button>

                        <Button
                          color={!activeStatus ? 'primary' : 'secondary'}
                          onClick={() => {
                            setActiveStatus(false);
                          }}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </AvGroup>
                  </Col>
                  <Col md="6">
                    <AvGroup>
                      <Label id="required" for="mmama-entity-required">
                        Is Required
                      </Label>
                      <ButtonGroup style={{ marginLeft: '30px' }}>
                        <Button
                          color={mandatoryStatus ? 'primary' : 'secondary'}
                          disabled={!hasUpdateAccess}
                          onClick={() => setMandatoryStatus(true)}
                        >
                          Yes
                        </Button>
                        <Button
                          color={!mandatoryStatus ? 'primary' : 'secondary'}
                          disabled={!hasUpdateAccess}
                          onClick={() => setMandatoryStatus(false)}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </AvGroup>
                  </Col>
                </Row>

                <br />
                <Row className="justify-content-left">
                  <Col md="6">
                    <AvGroup>
                      <Label id="enDescription" for="mmamaEntity-enDescription">
                        English Description
                      </Label>
                      <AvField
                        id="mmamaEntity-enDescription"
                        type="text"
                        name="enDescription"
                        disabled={!hasUpdateAccess}
                        validate={{
                          required: { value: true, errorMessage: 'This field is required' }
                        }}
                      />
                    </AvGroup>
                  </Col>
                  <Col md="6">
                    <AvGroup>
                      <Label id="stDescription" for="mmamaEntity-stDescription">
                        Local Language Description
                      </Label>
                      <AvField
                        id="mmamaEntity-stDescription"
                        type="text"
                        name="stDescription"
                        disabled={!hasUpdateAccess}
                        validate={{
                          required: { value: true, errorMessage: 'This field is required' }
                        }}
                      />
                    </AvGroup>
                  </Col>
                  <Col md="6">
                    <AvGroup>
                      <Label for="mmama-entity-country">Country</Label>
                      <AvInput
                        id="mmama-entity-country"
                        type="select"
                        className="form-control"
                        name="countryId"
                        validate={{
                          required: { value: true, errorMessage: 'This field is required' }
                        }}
                        disabled={!isNew}
                        value={isNew ? activeCountry?.id : mmamaEntityEntity?.countryId}
                        onChange={onCountryChange}>
                        {regCountriesList
                          && (props.isAdmin ? regCountriesList.map(country => (
                            <option value={country.id} key={country.id}>
                              {country.name}
                            </option>
                          )) : regCountriesList.map(country => (
                            props.userCountryId === country.id && <option value={country.id} key={country.id}>
                              {country.name}
                            </option>
                          )))}
                      </AvInput>
                    </AvGroup>
                  </Col>
                  <Col md="6">
                    <AvGroup>
                      <Label id="displayOrder" for="mmama-entity-displayOrder">
                        Display Order
                      </Label>
                      <AvField
                        id="mmama-entity-displayOrder"
                        type="number"
                        name="displayOrder"
                        disabled={!hasUpdateAccess}
                        validate={{
                          required: { value: true, errorMessage: 'This field is required' }
                        }}
                      />
                    </AvGroup>
                  </Col>
                  <Col md="6">
                    <AvGroup>
                      <Label for="mmama-entity-master">Feedback Entity</Label>
                      <AvField
                        id="mmama-entity-master"
                        type="select"
                        className="form-control"
                        name="entityMasterId"
                        validate={{
                          required: { value: true, errorMessage: 'This field is required' }
                        }}
                        disabled={!isNew}
                        value={isNew ? activeMasterEntity?.id : mmamaEntityEntity?.entityMasterId}
                        onChange={onMasterEntityChange}>
                        {masterEntities
                          && (props.isAdmin ? masterEntities.map(masterEntity => {
                              return (
                                <option value={masterEntity.id} key={masterEntity.id}>
                                  {masterEntity.entityName}
                                </option>
                              );
                            }) : regCountriesList.map(country => (
                            props.userCountryId === country.id && <option value={country.id} key={country.id}>
                              {country.name}
                            </option>
                          )))}
                      </AvField>
                    </AvGroup>
                  </Col>
                </Row>
              </div>

              <br />
              <Button tag={Link} id="cancel-save" onClick={handleClose} replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={!hasUpdateAccess || updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  mmamaEntityEntity: storeState.mmamaEntity.entity,
  loading: storeState.mmamaEntity.loading,
  updating: storeState.mmamaEntity.updating,
  updateSuccess: storeState.mmamaEntity.updateSuccess,
  masterEntities: storeState.mmamaEntity.masterEntities,
  countries: storeState.region.countries,
  userCountryId: storeState.authentication.userCountryId,
  hasUpdateAccess: hasAnyPermission(storeState.authentication.permissions, ['ADMIN', 'ENTITIES_MODIFY']),
  isAdmin: hasAnyPermission(storeState.authentication.account.roles, ['ADMIN']),
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  getCountries,
  getMasterEntities,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MmamaEntityUpdate);
